import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ReactiveFormsModule} from "@angular/forms";
import * as components from "./components";
import * as directives from "./directives";
import {CommonFilterService, CommonService, DocumentBaseService} from "@amlDocument/services";
import {CoreModule} from "../../core";
import {NgSelectModule} from "@ng-select/ng-select";
import {NgbModule} from "@ng-bootstrap/ng-bootstrap";
import {NgJsonEditorModule} from "ang-jsoneditor";
import {NgxMaskModule} from "ngx-mask";
import {UiSwitchModule} from "ngx-ui-switch";
import {DictionariesModule} from "../../dictionaries";

const declarationsAndExports = [
  // directives
  directives.ShowFormGroupDirective,
  directives.ShowFormControlDirective,
  directives.ChangeValidationFormControlDirective,
  // errors modal on save doc
  components.SaveErrorModalComponent,
  // lists
  components.DeletedListComponent,
  components.ArchiveListComponent
];

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    NgSelectModule,
    NgbModule,
    NgJsonEditorModule,
    ReactiveFormsModule,
    NgxMaskModule.forRoot(),
    UiSwitchModule.forRoot({
      size: 'medium',
      color: '#ae0000'
    }),
    DictionariesModule,
    CoreModule
  ],
  declarations: [...declarationsAndExports],
  exports: [...declarationsAndExports],
  providers: [DocumentBaseService, CommonService, CommonFilterService]
})
export class DocumentFormModule { }
